
<template>
  <div class="info-wrap py-5">
    <div class="container">

      <!-- Section Historique -->
      <div class="row align-items-center mb-2 section-row">
        <div class="col-md-6" :class="{'order-md-2': false}">
          <img src="../../assets/images/photo 26.jpg" alt="Historique" class="section-img">
        </div>
        <div class="col-md-6">
          <!-- <h3 class="section-title">Historique</h3> -->
          <p class="section-text">
           Au regard des divers défis de la vie de foi et des recommandations de Ecclesia in Africa, 103 et de Africӕ munus, 136, un projet de Centre Culturel Catholique fut proposé par le Père Rodrigue Gbédjinou à Mgr Antoine Ganyé, le 19 avril 2016 et exposé à son conseil le même jour. L’importance et la nécessité du projet furent relevées. Ce dernier, réélaboré, fut présenté le 3 novembre 2016 à Mgr Roger Houngbédji qui donna ses vives appréciations pour sa réalisation. Celui-ci fut assumé par le diocèse de Cotonou, comme École d’Initiation Théologique et Pastorale, par le décret du 15 novembre 2017.
Le 2 février 2018, par une messe solennelle présidée par Mgr Roger Houngbédji et concélébrée par Mgr Antoine Ganyé, Mgr Barthélemy Adoukonou et près d’une trentaine de prêtres, et la bénédiction des lieux totalement rénovés sur la Paroisse Saint Michel de Cotonou, s’ouvrait l’Ecole d’Initiation Théologique et Pastorale. Et le lundi 5 février, une brève rencontre avec le Père Rodrigue Gbédjinou (directeur), assisté des Pères Ambroise Kinhoun et Mathieu Aïfan, lançait les activités académiques.
Le 8 janvier 2022, les bâtiments du site aménagé de l’EITP, à côté du Collège Père Aupiais à Gbégamey, furent bénis par le père Rodrigue Gbédjinou. Et les cours s’y déroulent désormais. 

          </p>
        </div>
      </div>

      <!-- Section Mission -->
      
      <!-- Bouton Télécharger décret -->
      <!-- <div class="text-center mt-4">
  <a 
    href="/Decret.pdf"
    download="Decret.pdf"
    class="btn-download"
  >
    Télécharger décret
  </a>
</div> -->
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: "InfoSections",
};
</script>

<style scoped>
.info-wrap {
  background-color: #f8f9fa;
}

.section-row {
  padding: 20px 0;
}

.section-img {
  width: 100%;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.section-img:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
}

.section-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #0b1b3f;
  margin-bottom: 15px;
}

.section-text {
  font-size: 1rem;
  color: #6c757d;
  line-height: 1.7;
  text-align: justify;
}

.btn-download {
  background-color: #ffc107;
  color: #0b1b3f;
  font-weight: 700;
  padding: 12px 25px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-download:hover {
  background-color: #e0a800;
  transform: translateY(-2px);
}


</style>
